import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { BLOG, BLOG_DETAIL } from '../../Routes/RouteConstent'
import { getBlogCardImage } from '../../Screens/Blog/blogImageUtils'

const BlogCrad = ({ blog }: any) => {
    const navigate = useNavigate();
    const featured = blog?.lastes_blog;
    const sidePosts = Array.isArray(blog?.blogs) ? blog.blogs : [];
    const hasContent = Boolean(featured) || sidePosts.length > 0;

    if (!hasContent) {
        return null;
    }

    const goToBlog = (item: any) => {
        if (!item) return;
        if (item.external_url) {
            window.location.href = item.external_url;
            return;
        }
        if (item.slug) {
            navigate(BLOG_DETAIL.replace(":slug", item.slug));
            return;
        }
        if (item.url) {
            window.location.href = item.url;
        }
    };

    return (
        <section className='latest-news mt-3 pb-5'>
            <Container>
                <Row>
                    <div className='col-lg-12 col-md-12'>
                        <Row>
                            <div className='col-lg-12 text-left'><h2 className='section-heading'>Latest <span className='head-bold'>News</span></h2></div>
                        </Row>

                        <Row>
                            {featured ? (
                            <div onClick={() => goToBlog(featured)} className='col-lg-6 col-md-6 col-sm-12 mb-3 mb-sm-3 mb-md-0 featured-blog-main' style={{ cursor: 'pointer' }}>
                                <div className='featured-blog d-flex flex-column'>
                                    <div className='featured-blog-img mb-3'>
                                        <img src={getBlogCardImage(featured)} className='img-responsive' alt="" />
                                    </div>
                                    <div className='blog-details d-flex flex-column ms-0 ms-md-3'>
                                        <div className='blog-date my-2'>
                                            <span>{featured?.days}</span>
                                        </div>
                                        <div className='blog-title'>
                                            <h3>{featured?.title} </h3>
                                        </div>
                                        <div className='blog-description'>
                                            <p>{featured?.summary}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ) : null}
                            <div className={`col-lg-6 col-md-6 col-sm-12 blog-list-container${featured ? "" : " w-100"}`}>
                                <div className='d-flex flex-column'>
                                    {sidePosts.map((resData: any) => (
                                        <div className='blog-list' key={resData?.id || resData?.slug} onClick={() => goToBlog(resData)} style={{ cursor: 'pointer' }}>
                                            <div className='d-flex flex-column flex-md-row'>
                                                <div className='blog-thumb-main me-3'>
                                                    <div className='blog-thumb'
                                                        style={{ backgroundImage: `url(${getBlogCardImage(resData)})` }}>
                                                    </div>
                                                </div>

                                                <div className='blog-details d-flex flex-column'>
                                                    <div className='blog-date my-2'>
                                                        <span>{resData?.days}</span>
                                                    </div>
                                                    <div className='blog-title'>
                                                        <h3>{resData?.title} </h3>
                                                    </div>
                                                    <div className='blog-description'>
                                                        <p>{resData?.summary}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Row>

                        <Row className='mb-5'>
                            <div className='col-lg-12 col-md-12 text-center my-3'>
                                <button className="w-auto primary-blue-btn px-5 my-4" onClick={() => navigate(BLOG)}>View All</button>
                            </div>
                        </Row>
                    </div>
                </Row>
            </Container>
        </section>
    )
}

export default BlogCrad
